<template>
  <div class="download-app-wrap" @click="open">
    <div class="btn">移动网站</div>
  </div>
</template>

<script>
export default {
  name: "open-mobile",
  data() {
    return {};
  },
  methods: {
    open() {
      window.open("https://m.me56.cn/");
    },
  },
};
</script>

<style scoped>
.download-app-wrap {
  position: fixed;
  top: calc(50% + 60px);
  right: 0;
  cursor: pointer;
  align-items: center;
  height: 70px;
  z-index: 99;
}
.btn {
  position: relative;
  font-size: 14px;
  color: #fff;
  font-weight: 700;
  height: 40px;
  width: 40px;
  padding: 5px;
  border-radius: 25px;
  background-color: #1c96d4;
  margin-left: 5px;
  text-align: center;
  vertical-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/page/common/OpenMobile.vue